var map = {
	"./matomo-script": [
		1989,
		9
	],
	"./matomo-script.tsx": [
		1989,
		9
	],
	"./messages": [
		4848,
		9,
		4848
	],
	"./messages.tsx": [
		4848,
		9,
		4848
	],
	"./png/Cover_Report_EN.png": [
		4025,
		9,
		4025
	],
	"./png/Cover_Report_ES.png": [
		2541,
		9,
		2541
	],
	"./png/Cover_Report_FR.png": [
		7974,
		9,
		7974
	],
	"./png/EF_CChildhood_Cover.png": [
		143,
		9,
		143
	],
	"./png/story-background/child-power-small.png": [
		5548,
		9,
		5548
	],
	"./png/story-background/childhood-strides-small.png": [
		9830,
		9,
		7707
	],
	"./png/story-background/climate-action-small.png": [
		9258,
		9,
		9258
	],
	"./png/story-background/equality-for-some-small.png": [
		9737,
		9,
		9737
	],
	"./png/story-background/eyes-on-equality-small.png": [
		5195,
		9,
		5195
	],
	"./png/story-background/free-to-be-young-small.png": [
		6247,
		9,
		6247
	],
	"./png/story-background/future-fortunes-small.png": [
		4176,
		9,
		4176
	],
	"./png/story-background/global-citizens-small.png": [
		3334,
		9,
		3334
	],
	"./png/story-background/global-outlook-small.png": [
		9777,
		9,
		9777
	],
	"./png/story-background/go-to-sources-small.png": [
		8632,
		9,
		8632
	],
	"./png/story-background/is-scrolling-believing-small.png": [
		1966,
		9,
		1966
	],
	"./png/story-background/mental-burdens-small.png": [
		9741,
		9,
		9741
	],
	"./png/story-background/online-opportunities-small.png": [
		7144,
		9,
		7144
	],
	"./png/story-background/online-risks-small.png": [
		1681,
		9,
		1681
	],
	"./png/story-background/the-other-climate-crisis-small.png": [
		658,
		9,
		658
	],
	"./png/story-background/under-pressure-small.png": [
		6654,
		9,
		6654
	],
	"./png/story-background/where-you-call-home-small.png": [
		9123,
		9,
		9123
	],
	"./png/unicef-changing-childhood-report-cover-en.png": [
		9204,
		9,
		9204
	],
	"./svg/icon-caret-down": [
		6486,
		9,
		6486
	],
	"./svg/icon-caret-down.tsx": [
		6486,
		9,
		6486
	],
	"./svg/icon-caret-left": [
		5498,
		9
	],
	"./svg/icon-caret-left.tsx": [
		5498,
		9
	],
	"./svg/icon-caret-up": [
		9293,
		9,
		9293
	],
	"./svg/icon-caret-up.tsx": [
		9293,
		9,
		9293
	],
	"./svg/icon-copy-link": [
		6436,
		9,
		6436
	],
	"./svg/icon-copy-link.tsx": [
		6436,
		9,
		6436
	],
	"./svg/icon-download": [
		2241,
		9,
		2241
	],
	"./svg/icon-download.tsx": [
		2241,
		9,
		2241
	],
	"./svg/icon-drag-indicator": [
		4538,
		9
	],
	"./svg/icon-drag-indicator.tsx": [
		4538,
		9
	],
	"./svg/icon-email": [
		747,
		9,
		747
	],
	"./svg/icon-email.tsx": [
		747,
		9,
		747
	],
	"./svg/icon-facebook": [
		348,
		9,
		348
	],
	"./svg/icon-facebook.tsx": [
		348,
		9,
		348
	],
	"./svg/icon-globe": [
		4977,
		9
	],
	"./svg/icon-globe.tsx": [
		4977,
		9
	],
	"./svg/icon-info": [
		2994,
		9
	],
	"./svg/icon-info.tsx": [
		2994,
		9
	],
	"./svg/icon-sharing": [
		8561,
		9,
		8561
	],
	"./svg/icon-sharing.tsx": [
		8561,
		9,
		8561
	],
	"./svg/icon-twitter": [
		5579,
		9,
		4330
	],
	"./svg/icon-twitter.tsx": [
		5579,
		9,
		4330
	],
	"./svg/icon-whatsapp": [
		7271,
		9,
		7271
	],
	"./svg/icon-whatsapp.tsx": [
		7271,
		9,
		7271
	],
	"./svg/story-background/child-power-small.svg": [
		6196,
		1,
		6196
	],
	"./svg/story-background/child-power.svg": [
		1676,
		1,
		1676
	],
	"./svg/story-background/childhood-strides-small.svg": [
		4252,
		1,
		4252
	],
	"./svg/story-background/childhood-strides.svg": [
		3719,
		1,
		8534
	],
	"./svg/story-background/climate-action-small.svg": [
		2393,
		1,
		2393
	],
	"./svg/story-background/climate-action.svg": [
		434,
		1,
		434
	],
	"./svg/story-background/equality-for-some-small.svg": [
		5624,
		1,
		5624
	],
	"./svg/story-background/equality-for-some.svg": [
		4099,
		1,
		4099
	],
	"./svg/story-background/eyes-on-equality-small.svg": [
		9927,
		1,
		9927
	],
	"./svg/story-background/eyes-on-equality.svg": [
		8559,
		1,
		8559
	],
	"./svg/story-background/free-to-be-young-small.svg": [
		8643,
		1,
		8643
	],
	"./svg/story-background/free-to-be-young.svg": [
		3904,
		1,
		3904
	],
	"./svg/story-background/future-fortunes-small.svg": [
		4292,
		1,
		4292
	],
	"./svg/story-background/future-fortunes.svg": [
		9681,
		1,
		9681
	],
	"./svg/story-background/global-citizens-2021.svg": [
		71,
		1,
		71
	],
	"./svg/story-background/global-citizens-small-2021.svg": [
		4684,
		1,
		4684
	],
	"./svg/story-background/global-citizens-small.svg": [
		2317,
		1,
		2317
	],
	"./svg/story-background/global-citizens.svg": [
		2439,
		1,
		2439
	],
	"./svg/story-background/global-outlook-small.svg": [
		2558,
		1,
		2558
	],
	"./svg/story-background/global-outlook.svg": [
		7183,
		1,
		7183
	],
	"./svg/story-background/go-to-sources-2021-small.svg": [
		7657,
		1,
		7657
	],
	"./svg/story-background/go-to-sources-2021.svg": [
		4445,
		1,
		4445
	],
	"./svg/story-background/go-to-sources-small.svg": [
		5105,
		1,
		5105
	],
	"./svg/story-background/go-to-sources.svg": [
		9810,
		1,
		9810
	],
	"./svg/story-background/is-scrolling-believing-2021-small.svg": [
		4434,
		1,
		4434
	],
	"./svg/story-background/is-scrolling-believing-2021.svg": [
		6420,
		1,
		6420
	],
	"./svg/story-background/is-scrolling-believing-small.svg": [
		8822,
		1,
		8822
	],
	"./svg/story-background/is-scrolling-believing.svg": [
		6361,
		1,
		6361
	],
	"./svg/story-background/mental-burdens-small.svg": [
		3160,
		1,
		3160
	],
	"./svg/story-background/mental-burdens.svg": [
		8320,
		1,
		8320
	],
	"./svg/story-background/online-opportunities-small.svg": [
		5438,
		1,
		5438
	],
	"./svg/story-background/online-opportunities.svg": [
		4866,
		1,
		4866
	],
	"./svg/story-background/online-risks-small.svg": [
		2551,
		1,
		2551
	],
	"./svg/story-background/online-risks.svg": [
		6503,
		1,
		6503
	],
	"./svg/story-background/the-other-climate-crisis-2021-small.svg": [
		7332,
		1,
		7332
	],
	"./svg/story-background/the-other-climate-crisis-2021.svg": [
		8967,
		1,
		8967
	],
	"./svg/story-background/the-other-climate-crisis-small.svg": [
		5496,
		1,
		5496
	],
	"./svg/story-background/the-other-climate-crisis.svg": [
		6575,
		1,
		7861
	],
	"./svg/story-background/under-pressure-small.svg": [
		9313,
		1,
		9313
	],
	"./svg/story-background/under-pressure.svg": [
		2365,
		1,
		2365
	],
	"./svg/story-background/where-you-call-home-2021-small.svg": [
		673,
		1,
		673
	],
	"./svg/story-background/where-you-call-home-2021.svg": [
		2340,
		1,
		2340
	],
	"./svg/story-background/where-you-call-home-small.svg": [
		6091,
		1,
		6091
	],
	"./svg/story-background/where-you-call-home.svg": [
		6283,
		1,
		6283
	],
	"./svg/unicef-logo/desktop/ar": [
		5477,
		9,
		5477
	],
	"./svg/unicef-logo/desktop/ar.tsx": [
		5477,
		9,
		5477
	],
	"./svg/unicef-logo/desktop/bn": [
		8896,
		9,
		8896
	],
	"./svg/unicef-logo/desktop/bn.tsx": [
		8896,
		9,
		8896
	],
	"./svg/unicef-logo/desktop/en": [
		9399,
		9,
		9399
	],
	"./svg/unicef-logo/desktop/en.tsx": [
		9399,
		9,
		9399
	],
	"./svg/unicef-logo/desktop/es": [
		6619,
		9,
		6619
	],
	"./svg/unicef-logo/desktop/es.tsx": [
		6619,
		9,
		6619
	],
	"./svg/unicef-logo/desktop/fr": [
		697,
		9,
		697
	],
	"./svg/unicef-logo/desktop/fr.tsx": [
		697,
		9,
		697
	],
	"./svg/unicef-logo/desktop/hi": [
		7315,
		9,
		7315
	],
	"./svg/unicef-logo/desktop/hi.tsx": [
		7315,
		9,
		7315
	],
	"./svg/unicef-logo/desktop/id": [
		1717,
		9,
		1717
	],
	"./svg/unicef-logo/desktop/id.tsx": [
		1717,
		9,
		1717
	],
	"./svg/unicef-logo/desktop/pt": [
		6648,
		9,
		6648
	],
	"./svg/unicef-logo/desktop/pt.tsx": [
		6648,
		9,
		6648
	],
	"./svg/unicef-logo/desktop/sw": [
		3666,
		9,
		3666
	],
	"./svg/unicef-logo/desktop/sw.tsx": [
		3666,
		9,
		3666
	],
	"./svg/unicef-logo/mobile/ar": [
		5157,
		9,
		5157
	],
	"./svg/unicef-logo/mobile/ar.tsx": [
		5157,
		9,
		5157
	],
	"./svg/unicef-logo/mobile/bn": [
		9230,
		9,
		9230
	],
	"./svg/unicef-logo/mobile/bn.tsx": [
		9230,
		9,
		9230
	],
	"./svg/unicef-logo/mobile/en": [
		8915,
		9,
		8915
	],
	"./svg/unicef-logo/mobile/en.tsx": [
		8915,
		9,
		8915
	],
	"./svg/unicef-logo/mobile/es": [
		9907,
		9,
		9907
	],
	"./svg/unicef-logo/mobile/es.tsx": [
		9907,
		9,
		9907
	],
	"./svg/unicef-logo/mobile/fr": [
		8408,
		9,
		8408
	],
	"./svg/unicef-logo/mobile/fr.tsx": [
		8408,
		9,
		8408
	],
	"./svg/unicef-logo/mobile/hi": [
		8873,
		9,
		8873
	],
	"./svg/unicef-logo/mobile/hi.tsx": [
		8873,
		9,
		8873
	],
	"./svg/unicef-logo/mobile/id": [
		9157,
		9,
		9157
	],
	"./svg/unicef-logo/mobile/id.tsx": [
		9157,
		9,
		9157
	],
	"./svg/unicef-logo/mobile/pt": [
		2575,
		9,
		2575
	],
	"./svg/unicef-logo/mobile/pt.tsx": [
		2575,
		9,
		2575
	],
	"./svg/unicef-logo/mobile/sw": [
		2529,
		9,
		2529
	],
	"./svg/unicef-logo/mobile/sw.tsx": [
		2529,
		9,
		2529
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 585;
module.exports = webpackAsyncContext;